import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { dropdownMenuDarkVars, dropdownMenuLightVars } from './DropdownMenu.palette';

export const snapDropdownMenuPrimaryVars: MotifComponentProps<MotifComponent.DROPDOWN_MENU> = {
  ...dropdownMenuLightVars,
  '--dropdown-button-border-radius': m('--border-radius-xl'),
  '--dropdown-button-border-width': m('--border-width-s'),
  '--dropdown-button-border-color': m('--neutral-v700'),
  '--dropdown-button-hover-border-color': m('--neutral-v700'),
} as const;

export const snapDropdownMenuSecondaryVars: MotifComponentProps<MotifComponent.DROPDOWN_MENU> = {
  ...dropdownMenuDarkVars,
  '--dropdown-button-border-radius': m('--border-radius-xl'),
  '--dropdown-button-border-width': m('--border-width-s'),
  '--dropdown-button-border-color': m('--neutral-v0'),
  '--dropdown-button-hover-border-color': m('--neutral-v0'),
} as const;
